import { useAppSelector } from "../hooks";
import { getClasses } from "../utils";
import classes from "../styles/Logo.module.css";

const Logo: React.FC<{ className?: string }> = ({ className }) => {
  const visible = useAppSelector(
    (state) => state.details.logo,
    (o, n) => o !== n
  );
  const hiddenClass = visible ? "" : "hidden";

  return (
    <div className={getClasses(classes, "logo", hiddenClass, className)}></div>
  );
};

export default Logo;
